export default __webpack_public_path__ + "static/media/kitchen5-beforeD-1440w.f1bb83f9.webp";